// Immunizations subsection questionnaire constants
export enum ImmunizationsQuestionnaireItem {
  MEDICAL_BACKGROUND_IMMUNIZATIONS = 'medical-background/immunizations',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B = 'medical-background/immunizations/hep-b',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B_HEP_B = 'medical-background/immunizations/hep-b/hep-b',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_HEP_B_DATE = 'medical-background/immunizations/hep-b/date',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL = 'medical-background/immunizations/meningococcal',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL_MENINGOCOCCAL = 'medical-background/immunizations/meningococcal/meningococcal',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_MENINGOCOCCAL_DATE = 'medical-background/immunizations/meningococcal/date',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19 = 'medical-background/immunizations/covid-19',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19_COVID_19 = 'medical-background/immunizations/covid-19/covid-19',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_COVID_19_DATE = 'medical-background/immunizations/covid-19/date',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP = 'medical-background/immunizations/dtap',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP_DTAP = 'medical-background/immunizations/dtap/dtap',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_DTAP_DATE = 'medical-background/immunizations/dtap/date',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV = 'medical-background/immunizations/rsv',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV_RSV = 'medical-background/immunizations/rsv/rsv',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_RSV_DATE = 'medical-background/immunizations/rsv/date',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV = 'medical-background/immunizations/hpv',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV_HPV = 'medical-background/immunizations/hpv/hpv',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_HPV_DATE = 'medical-background/immunizations/hpv/date',
  MEDICAL_BACKGROUND_IMMUNIZATIONS_NOTES = 'medical-background/immunizations/notes'
}
